"use client";

import { motion } from "framer-motion";
import { Button } from "@heroui/react";
import { ArrowRight } from "@/components/icons";
import { FaqAccordion } from "@/components/faq-accordion";
import { useOpenChat } from "@/components/chatra-provider";
import { BreachesSection } from "./breaches-section";
import { BREACHES_FAQS } from "./breaches-data";

export function BreachesFaq() {
  const openChat = useOpenChat();
  return (
    <BreachesSection>
      <section className="w-full pb-40 text-left">
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: BREACHES_FAQS.map((f) => ({
                "@type": "Question",
                name: f.question,
                acceptedAnswer: { "@type": "Answer", text: f.answer },
              })),
            }),
          }}
        />
        <div className="grid gap-10 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="lg:sticky lg:top-24 lg:self-start"
          >
            <h2 className="max-w-[16ch] text-3xl font-semibold leading-[1.08] tracking-tight text-balance sm:text-4xl md:text-[46px]">
              Common questions
            </h2>
            <p className="mt-4 max-w-[48ch] text-base leading-relaxed text-text-tertiary sm:text-[17px]">
              Should you have any questions, our team is at your service.
            </p>

            <div className="heroui mt-7 hidden md:block">
              <Button
                variant="primary"
                className="h-10 min-h-10 w-full sm:w-auto gap-1.5 rounded-xl px-6 text-sm"
                onPress={openChat}
              >
                Chat with a human
                <ArrowRight className="size-3.5" />
              </Button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <FaqAccordion items={BREACHES_FAQS} />
          </motion.div>
        </div>
      </section>
    </BreachesSection>
  );
}
